import { ApiError } from './base/ApiError';

/**
 * 4xx系エラー
 */
export class ApiClientError extends ApiError {
  override name = 'ApiClientError';
}
